import { createStore } from "zustand/vanilla";
import { createBoundedUseStore } from "./usestore";

/**
 * Navigation guard store to prevent accidental navigation away from pages with unsaved changes
 * (created for Analysis page but can be reused)
 */
interface NavGuardState {
  /** When true, ContextLink will intercept navigation and call onIntercept */
  isGuarded: boolean;
  /** Called by ContextLink with the target URL when the guard is active */
  onIntercept: ((url: string) => void) | null;

  setGuard: (handler: (url: string) => void) => void;
  clearGuard: () => void;
}

export const navGuardStore = createStore<NavGuardState>()((set) => ({
  isGuarded: false,
  onIntercept: null,

  setGuard: (handler) => set({ isGuarded: true, onIntercept: handler }),
  clearGuard: () => set({ isGuarded: false, onIntercept: null }),
}));

const useNavGuardStore = createBoundedUseStore(navGuardStore);
export default useNavGuardStore;
